module.exports = __webpack_public_path__ + "static/media/cabs_icon.eb6ddb90.svg";